// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".U_J3N0IumZsOY5TJ81fQ{height:initial !important}#eyeDiv,#eyeDiv > div,#eyeDiv iframe{width:100% !important;height:100% !important}*:not(input):not(textarea){-webkit-user-select:none;-webkit-touch-callout:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rootOverridingStyle": "U_J3N0IumZsOY5TJ81fQ"
};
export default ___CSS_LOADER_EXPORT___;
